<template>
  <div>
    <toast-message
          :message="errmsg"
          type="error"
          :isToastEnable="toast"
          @close="(val) => toast = val"
        />
    <div class="row">
      <div class="col-3">
        <txt label="Name"
         name="dependent_name"
         type="text"
          v-model="model.name"
          :data-vv-name="name"
          v-validate="{required:true,regex:regexName}"
          :classname="errors.has('dependent_name')"
          :errormsg="errors.first('dependent_name')"
           />
      </div>
      <div class="col-3">
        <txt 
        label="Age" 
        type="text"
        name="age" 
        v-model="model.age"
        :data-vv-name="age"
        v-validate="{required:true ,numeric}"
        :classname="errors.has('age')"
        :errormsg="errors.first('age')"
        />

      </div>
      <div class="col-3">
        <txt
          label="Relationship"
          name="relation"
          v-model="model.relationship"
          :data-vv-name="relationship"
          v-validate="{required:true,regex:regexName}"
          :classname="errors.has('relation')"
          :errormsg="errors.first('relation')"
        />
      </div>
      <div class="col-3">
        <tl-select
          label="Marital Status"
          :options="['Unmarried', 'Married']"
          v-model="model.maritalstatus"
          @change="(val) => (model.maritalstatus = val)"
        ></tl-select>
      </div>
    </div>
    <footer>
      <popup-bottom-container>
        <template slot="end">
          <btn-grp class="form-button">
            <btn text="Back" type="secondary" @click="goBack" />
            <btn text="Save" type="primary" @click="saveDependent" />
          </btn-grp>
        </template>
      </popup-bottom-container>
    </footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { eventBus } from "@/main";
import * as globalRegexVar from "@/apis/config.js"

export default {
  name: "addDependentsPopup",
  data() {
    return {
      toast:false,
      regexName:null,
      errmsg:"",
      model: {
        name: "",
        age: "",
        relationship: "",
        maritalstatus: "",
        employee_id: "",
        it_plan_id: "",
      },
    };
  },
  activated() {
  },
  mounted() {
    // eventBus.$on("editDependent", dependentData => {
    //   //console.log("Its data", dependentData);
    // })
    this.nameFieldValidation()
    this.editDependent();
  
  },
  created() {
    eventBus.$on("editDependent", this.editDependent);
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
    }),
    
    nameFieldValidation()
    {
       this.regexName=globalRegexVar.Regex.ALPHA_NUM
    },

    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
  },
  methods: {
    ...mapActions({
      act_fetch: "onboard/employees/fetchAll",
      fetchLocations: "onboard/locations/fetchAll",
      act_get_dependents: "dashboard/payroll/incometax/getDependentList",
      act_get_active_it_plan: "dashboard/payroll/incometax/getActiveList",
      act_create: "dashboard/payroll/incometax/createDependents",
      act_update: "dashboard/payroll/incometax/update",
    }),

    async saveDependent() {
      try{
      let empId = this.$route.query.id;
      this.model.employee_id = empId;
      let data = await this.act_get_active_it_plan(empId);
      this.model.it_plan_id = data.data.payload.id;
      let res = await this.act_create(this.model);
      this.toast=false
      //console.log("Model", res.data.payload);
      this.$emit("saveDependent");
      }
       catch (err) {
        this.toast = true;
        this.errmsg = "Name,Age and Relationship fileds can't be blank"
      }
    },

    // Add here code for cancel button to hide popup By Bhushan
    goBack() {
      this.$emit("saveDependent");
    },

    async editDependent(dependentData) {
      //console.log("Dependent data", dependentData.id);
      let obj = {
        id: dependentData.id,
        name: this.model.name,
        age: this.model.age,
        relationship: this.model.relationship,
        maritalstatus: this.model.maritalstatus,
        employee_id: dependentData.employee_id,
        it_plan_id: dependentData.it_plan_id,
      };
      let res = await this.act_update(obj);
      //console.log("Approval data OBJ", obj);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins
@import "@/scss/_variables.scss";
</style>
